exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirm-modal{padding:0;border-radius:.25rem;max-width:18.75rem}.confirm-modal .modal__title{margin:0;padding:1rem;font-weight:700;text-align:center}.confirm-modal .modal__text{padding:1rem;padding-top:0}.confirm-modal .modal__buttons{border-top:1px solid #b0b8bf;padding:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ModalConfirm/ModalConfirm.scss
// module id = 686
// module chunks = 0